import React from 'react';
import CommunicateSourceModel from '../../../../model/CommunicateSource';
import useEnumerableModel from '../../../data/hooks/useEnumerableModel';
import useLabel from '../../utils/Translations/useLabel';
import SelectBoxFilter from './SelectBoxFilter';
const CommunicateSource = ({ label, ...rest }) => {
    const _label = useLabel('Source', label);
    const { options } = useEnumerableModel(CommunicateSourceModel);
    return (<SelectBoxFilter {...rest} options={options} title={_label}/>);
};
export default CommunicateSource;
